export const getCustomStyles = (isMobile, type) => {
    return {
        ...(type === 'viewer'
            ? {
                p: {
                    fontFamily: 'var(--comment-font-family)',
                    fontStyle: 'var(--comment-font-style)',
                    fontWeight: 'var(--comment-font-weight)',
                    color: 'var(--comment-text-color)',
                    fontSize: isMobile
                        ? 'var(--comment-font-size-mobile)'
                        : 'var(--comment-font-size-desktop)',
                    lineHeight: isMobile ? 1.43 : 1.5,
                    backgroundColor: 'transparent',
                },
            }
            : {
                editor: {
                    placeholder: {
                        color: 'var(--placeholder-text-color)',
                    },
                },
                p: {
                    color: 'var(--box-text-color)',
                    fontFamily: 'var(--placeholder-font-family)',
                    fontStyle: 'var(--placeholder-font-style)',
                    fontWeight: 'var(--placeholder-font-weight)',
                    fontSize: isMobile
                        ? 'var(--placeholder-font-size-mobile)'
                        : 'var(--placeholder-font-size-desktop)',
                    lineHeight: 1.5,
                    backgroundColor: 'transparent',
                },
            }),
    };
};
//# sourceMappingURL=ricos-styles.js.map